// extracted by mini-css-extract-plugin
export var gc = "GiftCard1-module__gc___I_0bh";